import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  PLATFORM_ID,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  HostListener,
  model,
} from '@angular/core';
import { Address } from 'node:cluster';
import { SelectCartComponent } from '../select-cart/select-cart.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { PaymentComponent } from '../payment/payment.component';
import { AddressComponent } from '../address/address.component';
import { GstComponent } from '../gst/gst.component';
import { CouponComponent } from '../coupon/coupon.component';
import { LoginComponent } from '../login/login.component';
import { ApiService } from '../../shared/services/api.service';
import { Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { CookieService } from '../../shared/services/cookie.service';
import { secureStorage } from '../../shared/services/secure-storage.service';
import { StorageService } from '../../shared/services/storage.service';
import { AuthService } from '../../shared/services/auth.service';
import { LoaderService } from '../../shared/services/loader.service';
import { NotificationService } from '../../shared/services/notification.service';
import { ProductNamePipe } from '../../shared/pipes/product-name.pipe';
import { Router } from '@angular/router';
import { CartService } from '../../shared/services/cart.service';
import {
  PaymentService,
  PaymentRequest,
  PaymentResponse,
} from '../../shared/services/payment.service';
import { BreadcrumComponent } from '../breadcrum/breadcrum.component';
import {
  appendOnlinePaymentFields,
  assignPaymentFlow,
  extractPriceBreakup,
  getOnlinePaymentFields,
  toAmountNumber,
} from '../../shared/constants/payment-flow';
import { BuyerVerificationService } from '../../shared/services/buyer-verification.service';
import { ModalService } from '../../shared/services/modal.service';
import {
  formatAddress as formatAddressUtil,
  hasAddress as hasAddressUtil,
  shouldShowCartBillingSection,
} from '../../shared/utils/address.utils';
import {
  canAddGstDetails as canAddGstDetailsUtil,
  canPlaceOrder as canPlaceOrderUtil,
} from '../../shared/utils/gst-eligibility';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SelectCartComponent,
    PaymentComponent,
    AddressComponent,
    GstComponent,
    CouponComponent,
    SelectCartComponent,
    LoginComponent,
    BreadcrumComponent,
    ProductNamePipe,
  ],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartComponent implements OnInit, OnDestroy {
  @Input() address!: Address;
  @Output() select = new EventEmitter<string>();
  @Input() isValid = false;
  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  addresses: any = [];
  selectedOption: string = '';
  selectedOptiondata: string = '';
  lable = 'Continue';
  cartItems: any = [];
  selectedItems: Map<string, { item: any; deliveryOption: string }> = new Map();

  // Method to get valid cart items (filters out null/undefined items)
  getValidCartItems() {
    return this.cartItems?.filter((item: any) => item != null) || [];
  }
  text: string = 'home';
  text1: any;
  Sidefilter: boolean = false;
  showAddAddressSection: boolean = false;
  showGstinSection: boolean = false;
  showCouponSection: boolean = false;
  payment: boolean = false;
  showPriceDetails: boolean = false;
  isLogging: boolean = false;
  wishlistItems: any[] = [];
  isWishlistLoading: boolean = false;
  isWishlistExpanded: boolean = false;
  isCartLoading: boolean = false;

  testValue: any = null;
  sub: Subscription = new Subscription();
  private destroy$ = new Subject<void>();
  userData: any;

  get canAddGstDetails(): boolean {
    return canAddGstDetailsUtil(this.userData);
  }

  get canPlaceOrder(): boolean {
    return canPlaceOrderUtil(this.userData);
  }
  type: any;
  selectedPartNumbers: any[] = [];
  orderDetail: any;
  // New properties for select all functionality
  selectAllChecked: boolean = false;
  priceDetails: any;
  oreder_number: any;
  isPaymentInProgress: boolean = false;
  isRemoveInProgress: boolean = false;
  ccavenue: any;

  // Add properties for login popup
  showLoginModal = false;
  currentAction: string = '';
  isMobile: boolean = false;
  cartBreadcrumbs: any[] = [{ label: 'Cart', url: '/cart' }];

  // Coupon-related properties
  availableCoupons: any[] = [];
  selectedCoupon: any = null;
  isCouponsLoading: boolean = false;
  payFullAmount: boolean = false;
  showFullPaymentConfirm: boolean = false;

  constructor(
    private apiService: ApiService,
    private storageService: StorageService,
    private authService: AuthService,
    private cartService: CartService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private ssrcookieService: CookieService,
    private localstorage: secureStorage,
    private loaderService: LoaderService,
    private router: Router,
    public paymentService: PaymentService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService,
    private buyerVerificationService: BuyerVerificationService,
    private modalService: ModalService,
  ) { }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Subscribe to authentication state changes
      this.authService.isLoggedIn$
        .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
        .subscribe((isLoggedIn) => {
          this.isLogging = isLoggedIn;
          // Update CTA label based on auth state and current step
          this.lable = !isLoggedIn
            ? 'Login & Continue'
            : this.payment
              ? 'Make Payment'
              : 'Continue';
          // If user is not logged in, show local storage items
          if (!isLoggedIn) {
            this.isCartLoading = false;
            this.loadLocalStorageItems();
            this.wishlistItems = [];
          } else {
            this.isCartLoading = true;
            this.getCartData();
            this.getUserDetails();
            // Non-blocking on load (prevents "blank" overlay flicker)
            this.getAddressData(false).then(() => {
              // After addresses are loaded, ensure current selection is set
              if (this.userData?.shipping_address?.id) {
                // Don't set testValue here, it will be set when Change is clicked
              }
            });
            this.loadWishlistItems();
          }
          this.cdr.markForCheck();
        });

      // Subscribe to user data changes
      this.authService.userData$
        .pipe(takeUntil(this.destroy$))
        .subscribe((userData) => {
          this.userData = userData || {};
          this.cdr.markForCheck();
        });

      // Subscribe to payment status changes
      this.paymentService.currentPaymentStatus
        .pipe(takeUntil(this.destroy$))
        .subscribe((status) => {
          if (status) {
            this.isPaymentInProgress = status.status === 'in_progress';
            this.handlePaymentStatusUpdate(status);
            this.cdr.markForCheck();
          }
        });
    }
  }

  selectAddress(addressId?: string): void {
    this.type = addressId; // 'shipping' or 'billing'
    if (addressId === 'billing') {
      this.selectedOption = 'billing';
    }

    // Get the current address ID based on type
    let currentAddressId: any = null;
    if (addressId === 'shipping' && this.userData?.shipping_address?.id) {
      currentAddressId = this.userData.shipping_address.id;
    } else if (addressId === 'billing' && this.userData?.billing_address?.id) {
      currentAddressId = this.userData.billing_address.id;
    }

    // Set testValue to current address ID so radio button is pre-selected
    // Use the same type as address.id (could be number or string)
    this.testValue = currentAddressId;

    // Always fetch fresh address list when modal opens
    this.getAddressData().then(() => {
      // After addresses are loaded, set the selected value again to ensure it matches
      if (currentAddressId) {
        // Find the address with matching ID to ensure type consistency
        const matchingAddress = this.addresses.find((addr: any) =>
          this.compareIds(addr.id, currentAddressId),
        );
        if (matchingAddress) {
          this.testValue = matchingAddress.id; // Use the exact ID from the address list
        } else {
          this.testValue = currentAddressId;
        }
      }

      // Force change detection to update radio button
      this.cdr.detectChanges();

      // Open modal after addresses are loaded
      this.Sidefilter = true;
      this.disableBodyScroll();
    });
  }

  // Helper method to compare IDs (handles both string and number types)
  compareIds(id1: any, id2: any): boolean {
    return String(id1) === String(id2);
  }

  closeModal(): void {
    this.Sidefilter = false;
    this.showAddAddressSection = false;
    this.showGstinSection = false;
    this.selectedOption = '';
    this.selectedOptiondata = '';
    this.showCouponSection = false;
    this.enableBodyScroll();
  }
  onClose() {
    this.Sidefilter = false;
    this.showAddAddressSection = false;
    this.showGstinSection = false;
    this.selectedOption = '';
    this.selectedOptiondata = '';
    this.showCouponSection = false;
    this.enableBodyScroll();
  }

  addNewAddress(): void {
    this.showAddAddressSection = true;
    // Implement add address functionality
  }

  applySelection(): void {
    const selectedAddressId = this.testValue; // This is the id of the selected address
    if (!selectedAddressId) {
      // Optionally show an error/toast
      return;
    }
    const payload = {
      id: selectedAddressId,
      shipping_address: this.type === 'shipping' ? true : '',
      billing_address: this.type === 'billing' ? true : '',
    };
    this.sub.add(
      this.apiService.updateAdress(payload).subscribe({
        next: (res) => {
          // Handle success (e.g., refresh addresses, close modal, show toast)
          this.Sidefilter = false;
          this.getUserDetails();
          this.getAddressData(); // Optionally refresh address list
        },
        error: (err) => {
          // Handle error (e.g., show error message)
        },
      }),
    );
  }

  getUserDetails(): void {
    const payload = {};
    this.sub.add(
      this.apiService.getUserDetails(payload).subscribe({
        next: (res) => {
          this.authService.login(res?.data);
          localStorage.setItem('userData1', JSON.stringify(res?.data));
          this.ssrcookieService.setItem('eol_user', JSON.stringify(res?.data));
          this.userData = res?.data;

          // Update auth service with latest data
          this.ssrcookieService.setItem('eol_user', JSON.stringify(res?.data));
        },
        error: (err) => {
          // this.notificationService.error(
          //   err?.error?.data?.msg ||
          //     'Failed to fetch user details. Please try again.',
          // );
        },
      }),
    );
  }

  onSave(): void {
    this.showAddAddressSection = false;
    this.getUserDetails();
    this.getAddressData();
    // Keep modal open so user can see the newly added address in the list
    this.Sidefilter = true;
  }

  gstmodel() {
    if (!this.canAddGstDetails) {
      return;
    }
    this.selectedOption = 'gstin';
    this.showGstinSection = true;
  }

  couponmodel() {
    this.fetchCouponsData(true);
    this.showCouponSection = true;
  }

  private getSelectedItemQuantity(item: any): number {
    if (!item) {
      return 0;
    }

    if (item?.part_type !== 'Scrap Part') {
      return (
        toAmountNumber(item?.selected_quantity) ||
        toAmountNumber(item?.quantity) ||
        toAmountNumber(item?.total_quantity) ||
        1
      );
    }

    const selectedUnit = String(item?.selectedUnit || item?.default_uom || '')
      .toLowerCase()
      .trim();

    if (selectedUnit === 'kg') {
      return (
        toAmountNumber(item?.customKgQuantity) ||
        toAmountNumber(item?.selected_quantity) ||
        toAmountNumber(item?.quantity) ||
        toAmountNumber(item?.total_quantity)
      );
    }

    if (selectedUnit === 'liter' || selectedUnit === 'litr') {
      return (
        toAmountNumber(item?.customLiterQuantity) ||
        toAmountNumber(item?.selected_quantity) ||
        toAmountNumber(item?.quantity) ||
        toAmountNumber(item?.total_quantity)
      );
    }

    const tonValue =
      item?.quantity === 'custom'
        ? toAmountNumber(item?.customTonQuantity)
        : toAmountNumber(item?.quantity);
    const tonToKg = tonValue > 0 ? tonValue * 1000 : 0;

    return (
      tonToKg ||
      toAmountNumber(item?.selected_quantity) ||
      toAmountNumber(item?.total_quantity)
    );
  }

  fetchCouponsData(showLoader: boolean = false) {
    const userData = JSON.parse(localStorage.getItem('userData1') || '{}');

    const selectedItemsArray = Array.from(this.selectedItems.values());

    let allItems: any[] = [];
    selectedItemsArray.forEach((selectedItem: any) => {
      const item = selectedItem.item;
      allItems.push({
        part_number: item?.part_number, //|| item?.inventory_id,
        part_type: item?.part_type,
        total_quantity: this.getSelectedItemQuantity(item),
        discounted_taxable: item.discounted_taxable,
        final_total: item.final_total,
        make: item.make,
        model: item.model,
        negotiated_price: item.negotiated_price,
        scrap_category: item.scrap_category,
        seller_code: item.seller_code_s,
        tax_s: item.tax_s,
      });
    });
    const payload = {
      items: allItems,
    };

    this.isCouponsLoading = true;
    if (showLoader) {
      this.loaderService.show();
    }
    this.sub.add(
      this.apiService.getBuyerBestOffer(payload).subscribe({
        next: (response) => {
          if (response.success && response.data) {
            // Transform the data to match the expected format
            this.availableCoupons = response.data.map((coupon: any) => ({
              ...coupon,
              savings: coupon.discount_amount,
              isActive: true,
            }));
          }
          this.isCouponsLoading = false;
          if (showLoader) {
            this.loaderService.hide();
          }
        },
        error: (err) => {
          // this.notificationService.error(
          //   err?.error?.data?.msg ||
          //     'Failed to fetch coupons. Please try again.',
          // );

          this.isCouponsLoading = false;
          if (showLoader) {
            this.loaderService.hide();
          }
        },
      }),
    );
  }

  onSaveCouponDetails(event: any) {
    this.selectedCoupon = event;
    this.showCouponSection = false;

    // Recalculate price with coupon
    if (this.authService.isLoggedIn) {
      this.getPriceBreakupWithCoupon();
    }
  }

  getPriceBreakupWithCoupon() {
    if (!this.authService.isLoggedIn || this.selectedItems.size === 0) {
      return;
    }

    const selectedItemsArray = Array.from(this.selectedItems.values());
    const parts = selectedItemsArray.map((selectedItem: any) => {
      const item = selectedItem.item;
      const totalQuantity = this.getSelectedItemQuantity(item);

      return {
        part_number: item?.part_number || item?.inventory_id,
        part_type: item?.part_type,
        total_quantity: totalQuantity,
      };
    });

    const payload: Record<string, unknown> = {
      coupon_code: this.selectedCoupon?.coupon_code || '',
      offer_id: this.selectedCoupon?.row_id || '',
      parts: parts,
    };
    assignPaymentFlow(payload, this.getOnlinePaymentPayload().payment_flow);

    this.loaderService.show();
    this.sub.add(
      this.apiService.getBuyNowPriceBreakup(payload).subscribe({
        next: (res) => {
          const breakup = extractPriceBreakup(res);
          if (res.success && breakup) {
            this.priceDetails = { ...breakup };
            this.cdr.detectChanges();
          }
          this.loaderService.hide();
        },
        error: (err) => {
          // this.notificationService.error(
          //   err.error.data?.msg || 'Failed to apply coupon. Please try again.',
          // );
          this.loaderService.hide();
        },
      }),
    );
  }

  copyToClipboard(text: string) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(
        () => {
          this.notificationService.success('Coupon code copied to clipboard!');
        },
        (err) => {
          console.error('Could not copy text: ', err);
        },
      );
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.notificationService.success('Coupon code copied to clipboard!');
      } catch (err) {
        console.error('Could not copy text: ', err);
        // this.notificationService.error(
        //   'Failed to copy order number. Please try again.',
        // );
      }
      document.body.removeChild(textArea);
    }
  }

  togglePriceDetails() {
    this.showPriceDetails = !this.showPriceDetails;
  }

  onItemSelectionChange(event: {
    item: any;
    selected: boolean;
    deliveryOption: string;
  }) {
    if (event.selected) {
      this.selectedItems.set(event.item.id.toString(), {
        item: event.item,
        deliveryOption:
          event.deliveryOption ||
          (event.item?.part_type === 'Scrap Part'
            ? 'Store Pickup'
            : 'Home Delivery'),
      });
    } else {
      this.selectedItems.delete(event.item.id.toString());
    }
    this.updateSelectAllState();

    // Recalculate price details for non-logged-in users when selection changes
    if (!this.authService.isLoggedIn) {
      this.calculateSelectedItemsPrice();
    }
  }

  isItemSelected(item: any): boolean {
    return this.selectedItems.has(item?.id?.toString());
  }

  // New methods for select all functionality
  getTotalCount(): number {
    return this.cartItems.length;
  }

  getSelectedCount(): number {
    return this.selectedItems.size;
  }

  getSelectionText(): string {
    const selected = this.getSelectedCount();
    const total = this.getTotalCount();
    if (total === 0) {
      return 'No Items in Cart';
    }
    return `${selected}/${total} Items Selected`;
  }

  isCartEmpty(): boolean {
    return (
      !this.cartItems ||
      this.cartItems.length === 0 ||
      this.getValidCartItems().length === 0
    );
  }


  continueShopping(): void {
    this.router.navigate(['/product-list']);
  }

  updateSelectAllState(): void {
    const total = this.getTotalCount();
    const selected = this.getSelectedCount();
    this.selectAllChecked = total > 0 && selected === total;
  }

  onSelectAllChange(checked: boolean): void {
    if (checked) {
      this.selectAllItems();
    } else {
      this.deselectAllItems();
    }

    // Recalculate price details for non-logged-in users
    if (!this.authService.isLoggedIn) {
      this.calculateSelectedItemsPrice();
    }
  }

  onSelectAllChangeEvent(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.onSelectAllChange(target.checked);
  }

  selectAllItems(): void {
    this.cartItems.forEach((item: any) => {
      const idStr = (item.id || item.inventory_id || item.part_number)?.toString();
      if (idStr && !this.selectedItems.has(idStr)) {
        this.selectedItems.set(idStr, {
          item: item,
          deliveryOption: item.deliveryOption
            ? item.deliveryOption
            : item?.part_type === 'Scrap Part'
              ? 'Store Pickup'
              : 'Home Delivery', // Default based on part type
        });
      }
    });
    this.selectAllChecked = true;
  }

  getBasePrice(): number {
    const orderTotal = Number(
      this.priceDetails?.order_total || this.priceDetails?.orderTotal || 0,
    );
    if (orderTotal > 0) {
      return orderTotal;
    }
    if (this.priceDetails?.base_price && Number(this.priceDetails.base_price) > 0) {
      return Number(this.priceDetails.base_price);
    }
    const selectedItemsArray = Array.from(this.selectedItems.values()).map(
      (e) => e.item,
    );
    const items =
      selectedItemsArray.length > 0 ? selectedItemsArray : this.cartItems;
    let total = 0;
    items.forEach((item: any) => {
      const qty =
        Number(item.selected_quantity) ||
        Number(item.total_quantity) ||
        Number(item.quantity) ||
        1;
      const price =
        Number(item.discounted_price) ||
        Number(item.taxable_amount) ||
        Number(item.price_s) ||
        0;
      total += price * qty;
    });
    return total;
  }

  getScrapBalanceAmount(): number {
    const remaining = Number(
      this.priceDetails?.remaining_booking_amount ||
        this.priceDetails?.remainingBookingAmount ||
        0,
    );
    if (remaining > 0) {
      return remaining;
    }
    const basePrice = this.getBasePrice();
    const bookingAmount = Number(this.priceDetails?.scrap_booking_amount) || 0;
    return Math.max(basePrice - bookingAmount, 0);
  }

  deselectAllItems(): void {
    this.selectedItems.clear();
    this.selectAllChecked = false;
  }

  showConfirmRemoveAllModal: boolean = false;

  confirmRemoveAll(): void {
    if (this.getSelectedCount() === 0) {
      return;
    }
    this.showConfirmRemoveAllModal = true;
    this.cdr.markForCheck();
  }

  cancelRemoveAll(): void {
    this.showConfirmRemoveAllModal = false;
    this.cdr.markForCheck();
  }

  executeRemoveAllItems(): void {
    this.showConfirmRemoveAllModal = false;
    this.removeAllItems();
  }

  removeAllItems(): void {
      let itemsToRemove = Array.from(this.selectedItems.values()).map(
        (item) => item.item,
      );
    if (itemsToRemove.length === 0) {
      itemsToRemove = this.getValidCartItems();
    }
    if (itemsToRemove.length === 0) {
      itemsToRemove = this.cartItems || [];
    }

    const selectedPartNumbers = itemsToRemove
      .map(
        (item: any) =>
          (item?.inventory_id || item?.part_number || item?.id)?.toString(),
      )
      .filter((id: string) => !!id);

    // Clear local storage regardless of auth state
    if (selectedPartNumbers.length > 0) {
      this.cartService.removeMultipleFromLocalStorage(selectedPartNumbers);
    }
    this.cartService.clearLocalStorageCart();

    if (selectedPartNumbers.length === 0) {
      this.deselectAllItems();
      this.cartItems = [];
      this.priceDetails = null;
      this.selectAllChecked = false;
      this.cartService.updateCartCount(0);
      this.cdr.detectChanges();
      return;
    }

    this.isRemoveInProgress = true;

    // If user is not logged in, remove from local storage only
    if (!this.authService.isLoggedIn) {
      this.deselectAllItems();
      this.cartItems = [];
      this.cleanupRemovedSelectedItems();
      this.updateSelectAllState();
      this.priceDetails = null;
      this.selectAllChecked = false;
      this.isRemoveInProgress = false;
      this.cartService.updateCartCount(0);
      this.cdr.detectChanges();
      return;
    }

    // Logged-in users: call API
    const payload = {
      cart_item_id_list: selectedPartNumbers,
    };

    // Optimistically update cart state immediately
    this.deselectAllItems();
    this.cartItems = [];
    this.priceDetails = null;
    this.selectAllChecked = false;
    this.cartService.updateCartCount(0);
    this.cdr.detectChanges();

    this.sub.add(
      this.apiService.removeCartData(payload).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.deselectAllItems();
            this.cartItems = [];
            this.priceDetails = null;
            this.selectAllChecked = false;
            this.cartService.clearLocalStorageCart();
            if (this.cartService) {
              this.cartService.updateCartCount(0);
              this.cartService.updateCartCountFromApi();
            }
            this.getCartData();
          } else {
            console.error('Failed to remove cart items:', res);
          }
          this.isRemoveInProgress = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error removing cart items:', err);
          this.isRemoveInProgress = false;
          this.getCartData();
        },
        complete: () => {
          this.isRemoveInProgress = false;
          this.cdr.detectChanges();
        },
      }),
    );
  }

  onItemRemoved(): void {
    if (!this.authService.isLoggedIn) {
      this.loadLocalStorageItems();
    } else {
      this.getCartData();
      this.loadWishlistItems();
    }
  }

  onSelectedPartNumbersChange(partNumbers: any[]): void {
    this.selectedPartNumbers = partNumbers;
  }

  onPriceDetailsChange(priceDetails: any): void {
    this.priceDetails = priceDetails;
  }

  hasBookingAmount(): boolean {
    return toAmountNumber(this.priceDetails?.scrap_booking_amount) > 0;
  }

  getOnlinePaymentPayload() {
    return getOnlinePaymentFields({
      payFullAmount: this.payFullAmount,
      bookingAmount: this.priceDetails?.scrap_booking_amount,
      totalAmount: this.priceDetails?.total_amount,
    });
  }



  getDisplayTotalAmount(): any {
    const totalAmount = toAmountNumber(
      this.priceDetails?.total_amount || this.priceDetails?.totalAmount,
    );
    if (totalAmount > 0) {
      return totalAmount.toFixed(2);
    }
    return '0.00';
  }

  onPayFullAmountChange(checked: boolean): void {
    this.payFullAmount = !!checked;
    this.showFullPaymentConfirm = false;
    this.cdr.detectChanges();
    this.getPriceBreakupWithCoupon();
  }

  confirmFullPayment(): void {
    this.payFullAmount = true;
    this.showFullPaymentConfirm = false;
    this.cdr.detectChanges();
    this.getPriceBreakupWithCoupon();
  }

  cancelFullPayment(): void {
    this.payFullAmount = false;
    this.showFullPaymentConfirm = false;
    this.cdr.detectChanges();
  }

  getSelectedPartNumbers(): any[] {
    return this.selectedPartNumbers;
  }

  gotoPayment() {
    const selectedPartNumbers = Array.from(this.selectedItems.values()).map(
      (item) => item.item.inventory_id,
    );
    const selectedPartDeliveryType = Array.from(
      this.selectedItems.values(),
    ).map((item: any) => item.deliveryOption);
    localStorage.removeItem('booking_page_product_data');
    localStorage.setItem(
      'booking_page_product_data',
      JSON.stringify(selectedPartNumbers),
    );
    localStorage.removeItem('cartbooking_page_product_data');

    // Convert Map to plain object for localStorage storage
    const selectedItemsObject = Object.fromEntries(this.selectedItems);
    localStorage.setItem(
      'cartbooking_page_product_data',
      JSON.stringify(selectedItemsObject),
    );

    // If logged out, open login instead of proceeding
    if (!this.authService.isLoggedIn) {
      this.openLoginPopup('other');
      return;
    }

    // Check if user is logged in - check for actual user data, not just truthy value
    if (
      !this.userData ||
      !this.userData.id ||
      Object.keys(this.userData).length === 0
    ) {
      this.openLoginPopup('other');
      return;
    }

    // Require a valid shipping address before proceeding to payment/update
    if (
      !this.hasValidShippingAddress() &&
      selectedPartDeliveryType.includes('Home Delivery')
    ) {
      this.showPaymentError('Please select a delivery address');
      return;
    }

    if (this.userData && !this.canPlaceOrder) {
      this.showPaymentError(
        BuyerVerificationService.ORDER_PROFILE_UPDATE_MESSAGE,
      );
      return;
    }

    if (this.selectedItems.size > 0) {
      this.payment = true;
      this.cartBreadcrumbs = [
        { label: 'Cart', url: '/cart' },
        { label: 'Payment', url: null },
      ];
      this.cdr.detectChanges();
      if (
        this.lable == 'Make Payment' &&
        this.payment === true &&
        this.selectedPartNumbers.length > 0
      ) {
        this.onMakePayment();
      } else {
        this.getCartDataPayment();
        // this.getCartData();
      }
      this.lable = 'Make Payment';
    } else {
    }
  }

  // Add method to handle login popup logic
  openLoginPopup(action: string = 'other'): void {
    this.currentAction = action;

    // For both mobile and desktop users, open login modal
    this.showLoginModal = true;
    this.modalService.openModal('cart-login-modal', () => this.closeLoginPopup());
  }

  closeLoginPopup() {
    this.showLoginModal = false;
    this.modalService.closeModal('cart-login-modal');
    // Refresh user data after login
    this.getUserDetails();
  }

  onLoginBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closeLoginPopup();
    }
  }

  // Add method for Buy Now popup payment
  paymentErrorMessage: string | null = null;

  private showPaymentError(message: string): void {
    this.paymentErrorMessage = message;
    this.notificationService.error(message);
    this.cdr.markForCheck();
  }

  async onMakePayment() {
    this.paymentErrorMessage = null;
    this.loaderService.show();
    // Check if user is logged in - check for actual user data, not just truthy value
    if (
      !this.userData ||
      !this.userData.id ||
      Object.keys(this.userData).length === 0
    ) {
      this.loaderService.hide();
      this.openLoginPopup('other');
      return;
    }
    const selectedPartDeliveryType = Array.from(
      this.selectedItems.values(),
    ).map((item: any) => item.deliveryOption);
    const selectedItemsObject = Object.fromEntries(this.selectedItems);
    // Check if address is selected
    if (!this.hasValidShippingAddress()) {
      this.loaderService.hide();
      this.showPaymentError('Please select a delivery address');
      return;
    }

    const orderGate =
      await this.buyerVerificationService.ensureCanCreateOrder(this.userData);
    if (!orderGate.allowed) {
      this.loaderService.hide();
      this.showPaymentError(orderGate.message);
      return;
    }

    // Create FormData for payment
    const payload = new FormData();
    payload.append('coupon_code', this.selectedCoupon?.coupon_code || '');
    payload.append('offer_id', this.selectedCoupon?.row_id || '');
    appendOnlinePaymentFields(payload, this.getOnlinePaymentPayload());

    localStorage.removeItem('createdOrderDetail');
    this.loaderService.show();
    this.sub.add(
      this.apiService.buyNow(payload).subscribe({
        next: (res) => {
          if (res.success) {
            this.orderDetail = res.data;
            localStorage.setItem(
              'createdOrderDetail',
              JSON.stringify(this.orderDetail),
            );

            this.oreder_number = this.orderDetail?.order_detail?.order_number;

            // Call payment service to get encrypted payment data
            this.initiatePayment();

            // this.router.navigate(['/order-confirmation'], { state: { orderDetail: this.orderDetail } });
            // this.m
            // alert('initiated payment.');
          }
          this.loaderService.hide();
        },
        error: (err) => {
          // this.notificationService.error(
          //   err.error.data?.msg ||
          //     'Failed to initiate payment. Please try again.',
          // );
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
  }

  async onMakeEnquiry() {
    this.paymentErrorMessage = null;
    this.loaderService.show();
    // Check if user is logged in - check for actual user data, not just truthy value
    if (
      !this.userData ||
      !this.userData.id ||
      Object.keys(this.userData).length === 0
    ) {
      this.loaderService.hide();
      this.openLoginPopup('other');
      return;
    }

    if (this.selectedItems.size === 0) {
      this.loaderService.hide();
      this.showPaymentError('Please select at least one item');
      return;
    }

    // Require valid shipping address before proceeding
    if (!this.hasValidShippingAddress()) {
      if (!this.payment) {
        this.payment = true;
        this.cartBreadcrumbs = [
          { label: 'Cart', url: '/cart' },
          { label: 'Payment', url: null },
        ];
        this.lable = 'Make Payment';
        this.getCartDataPayment();
      }
      this.loaderService.hide();
      this.showPaymentError('Please select a delivery address');
      return;
    }

    const orderGate =
      await this.buyerVerificationService.ensureCanCreateOrder(this.userData);
    if (!orderGate.allowed) {
      this.loaderService.hide();
      this.showPaymentError(orderGate.message);
      return;
    }

    // Create FormData for enquiry
    const payload = new FormData();
    payload.append('coupon_code', this.selectedCoupon?.coupon_code || '');
    payload.append('offer_id', this.selectedCoupon?.row_id || '');
    payload.append('is_enquiry', 'true');

    localStorage.removeItem('createdOrderDetail');
    this.loaderService.show();
    this.sub.add(
      this.apiService.buyNow(payload).subscribe({
        next: (res) => {
          if (res.success) {
            this.orderDetail = res.data;
            localStorage.setItem(
              'createdOrderDetail',
              JSON.stringify(this.orderDetail),
            );

            this.oreder_number = this.orderDetail?.order_detail?.order_number;
            const enquiryNumber = this.orderDetail?.enquiry_numbers?.[0] || '';
            this.notificationService.success('Enquiry submitted successfully');
            this.router.navigate(['/order-confirmation'], {
              queryParams: {
                success: 'true',
                order_id: this.oreder_number,
                is_enquiry: 'true',
                enquiry_number: enquiryNumber,
              },
              state: {
                orderDetail: this.orderDetail,
                isEnquiry: true,
                enquiryNumber,
              },
            });
          } else {
            this.showPaymentError(res?.data?.msg || 'Failed to submit enquiry');
          }
          this.loaderService.hide();
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.loaderService.hide();
          this.showPaymentError(
            err?.error?.data?.msg ||
            'Failed to submit enquiry. Please try again.',
          );
          this.cdr.markForCheck();
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
  }

  hasOnlyStorePickupItems(): boolean {
    if (this.selectedItems.size === 0) {
      return false;
    }
    const selectedPartDeliveryType = Array.from(
      this.selectedItems.values(),
    ).map((item: any) => item.deliveryOption);
    // Check if all selected items are Store Pickup
    return (
      selectedPartDeliveryType.length > 0 &&
      selectedPartDeliveryType.every((type: string) => type === 'Store Pickup')
    );
  }

  hasAddress(address: any): boolean {
    return hasAddressUtil(address);
  }

  formatAddress(address: any): string {
    return formatAddressUtil(address);
  }

  shouldShowDeliverySection(): boolean {
    return (
      !this.hasOnlyStorePickupItems() &&
      this.hasAddress(this.userData?.shipping_address)
    );
  }

  shouldShowCartBillingSection(): boolean {
    return shouldShowCartBillingSection(
      this.userData,
      this.hasOnlyStorePickupItems(),
    );
  }

  shouldShowAddAddressPrompt(): boolean {
    return (
      !this.hasAddress(this.userData?.shipping_address) &&
      !this.hasAddress(this.userData?.billing_address)
    );
  }

  getCartBillingAddress(): any {
    if (this.hasOnlyStorePickupItems()) {
      return (
        (this.hasAddress(this.userData?.billing_address)
          ? this.userData?.billing_address
          : null) || this.userData?.shipping_address
      );
    }
    return this.userData?.billing_address;
  }

  private hasValidShippingAddress(): boolean {
    return (
      this.hasAddress(this.userData?.shipping_address) ||
      this.hasAddress(this.userData?.billing_address)
    );
  }

  // Method to initiate payment using PaymentService
  initiatePayment() {
    if (!this.oreder_number) {
      console.error('Order number not available');
      // this.notificationService.error(
      //   'Order number not available. Please try again.',
      // );
      return;
    }

    // Create payment request payload
    const paymentPayload: PaymentRequest = {
      order_number: this.oreder_number,
      payment_flow: this.getOnlinePaymentPayload().payment_flow,
    };

    this.loaderService.show();
    // Call payment service to get encrypted payment data
    this.sub.add(
      this.paymentService.getEncryptedPaymentData(paymentPayload).subscribe({
        next: (response: PaymentResponse) => {
          if (response.success && response.data) {
            this.loaderService.hide();
            this.ccavenue = response?.data;
            let encRequest = response?.data;
            let ccavenuForm: FormGroup = this.formBuilder.group({
              encRequest: [encRequest?.encRequest],
              access_code: [this.ccavenue?.accessCode],
            });
            this.payWithCcavenu(ccavenuForm);

            // Update payment status
            this.paymentService.updatePaymentStatus({ status: 'in_progress' });
            this.isPaymentInProgress = true;

            // Store payment data
            this.paymentService.updatePaymentData(response.data);

            // Handle successful payment data
            // this.handlePaymentData(response.data);
          } else {
            this.loaderService.hide();
            console.error('Payment failed:', response.error);
            // this.notificationService.error(
            //   response?.data?.msg ||
            //     'Failed to get payment data: ' +
            //       'Failed to get payment data: ' +
            //       (response.error || 'Unknown error'),
            // );
          }
        },
        error: (error) => {
          console.error('Payment service error:', error);
          // this.notificationService.error(
          //   error?.error?.data?.msg ||
          //     'Payment service error. Please try again.',
          // );
          this.loaderService.hide();
        },
      }),
    );
  }

  payWithCcavenu(formGroup: FormGroup) {
    // localStorage.removeItem('productOfferData');

    const myform = document.createElement('form');
    myform.method = 'POST'; //this.ccavenue.ccavenue_url;//
    myform.action = `${this.ccavenue.ccavenue_url}&encRequest=${this.ccavenue.encRequest}&access_code=${this.ccavenue.access_code}`;
    let input: any;
    for (const [key, value] of Object.entries(formGroup.value)) {
      input = document.createElement('input');
      input.name = key;
      input.id = key;
      input.value = value;
      myform.appendChild(input);
    }
    myform.style.display = 'none';
    myform.append('Content-Type', 'application/x-www-form-urlencoded');
    myform.append(
      'Accept',
      'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
    );
    document.body.appendChild(myform);
    myform.submit();
  }
  // Handle payment data received from CCAvenue
  getCartData() {
    this.isCartLoading = true;
    this.loaderService.show();
    const payload = {
      offset: 0,
      limit: 100,
      action_type: 'GET_LIST',
      get_selected_parts: '',
    };

    this.sub.add(
      this.apiService.getCartData(payload).subscribe({
        next: (res: any) => {
          if (res.success && res.data) {
            this.cdr.detectChanges();
              const totalResult = Number(
                res.data.total_result ??
                res.data.total_results ??
                res.data.total_count ??
                res.data.total_records ??
                -1,
              );
              const cartItemsList = (
                res.data.cart_items ||
                res.data.cart_item_list ||
                res.data.items ||
                res.data.cart ||
                []
              ).filter((item: any) => item != null);

              if (cartItemsList.length > 0 && totalResult !== 0) {
                this.priceDetails = res.data.get_price_breakup;
                this.cartItems = cartItemsList;

                // Clean up selected items that no longer exist in cart
                this.cleanupRemovedSelectedItems();

                // Auto-select all items by default
                this.selectAllItems();

                this.updateSelectAllState(); // Update select all state after loading cart data

                // Fetch available coupons when cart is loaded
                this.fetchCouponsData();
              } else {
                  // Handle empty cart response: API returned 0 items or total_result === 0
                  this.cartItems = [];
                  this.priceDetails = null;
                  this.selectedItems.clear();
                  this.selectAllChecked = false;

                  if (this.authService.isLoggedIn) {
                    this.cartService?.clearLocalStorageCart();
                    if (this.cartService) {
                      this.cartService.updateCartCount(0);
                    }
                  } else {
                    const localItems =
                      this.cartService?.getLocalStorageCartItems?.() || [];
                    if (localItems.length > 0) {
                      this.loadLocalStorageItems();
                    } else if (this.cartService) {
                      this.cartService.updateCartCount(0);
                    }
                  }
                }
              } else {
                this.cartItems = [];
                this.priceDetails = null;
                this.selectedItems.clear();
                this.selectAllChecked = false;
                if (this.authService.isLoggedIn) {
                  this.cartService?.clearLocalStorageCart();
                } else {
                  const localItems =
                    this.cartService?.getLocalStorageCartItems?.() || [];
                  if (localItems.length > 0) {
                    this.loadLocalStorageItems();
                  }
                }
                if (this.cartService && this.cartItems.length === 0) {
                  this.cartService.updateCartCount(0);
                }
              }
              this.isCartLoading = false;
              this.loaderService.hide();
              this.cdr.detectChanges();
            },
            error: (err: any) => {
              console.error('Error fetching cart data:', err);
              this.isCartLoading = false;
                if (!this.authService.isLoggedIn) {
                  const localItems =
                    this.cartService?.getLocalStorageCartItems?.() || [];
                  if (localItems.length > 0) {
                    this.loadLocalStorageItems();
                  } else {
                    this.cartItems = [];
                    this.priceDetails = null;
                  }
                } else {
                  this.cartItems = [];
                  this.priceDetails = null;
                }
                this.loaderService.hide();
                this.cdr.detectChanges();
              },
              complete: () => {
                this.isCartLoading = false;
                this.loaderService.hide();
                this.cdr.detectChanges();
              },
      }),
    );
  }

  getCartDataPayment() {
    this.loaderService.show();
    const cartItems = Array.from(this.selectedItems.entries()).map(
      ([id, data]) => ({
        part_number: data.item.inventory_id,
        delivery_type:
          data.deliveryOption ||
          (data.item?.part_type === 'Scrap Part'
            ? 'Store Pickup'
            : 'Home Delivery'),
      }),
    );

    const payload = {
      offset: 0,
      limit: 10,
      action_type: 'Update List',
      cart_items: cartItems,
      coupon_code: this.selectedCoupon?.coupon_code || '',
      offer_id: this.selectedCoupon?.row_id || '',
    };

    // if (!this.hasValidShippingAddress()) {
    //   this.loaderService.hide();
    //   alert('Please select a delivery address');
    //   return;
    // }
    this.sub.add(
      this.apiService.getCartData(payload).subscribe({
        next: (res: any) => {
          if (res.success && res.data && res.data.cart_items) {
            this.cartBreadcrumbs = [
              { label: 'Cart', url: '/cart' },
              { label: 'Payment', url: null },
            ];
            this.cdr.detectChanges();
          }
          this.loaderService.hide();
        },
        error: (err: any) => {
          console.error('Error updating cart data:', err);
          // this.notificationService.error(
          //   err?.error?.data?.msg ||
          //     'Failed to update cart data. Please try again.',
          // );
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
  }

  toggleWishlistSection(): void {
    this.isWishlistExpanded = !this.isWishlistExpanded;
  }

  private loadWishlistItems(limit: number = 10): void {
    if (!this.authService.isLoggedIn) {
      this.wishlistItems = [];
      return;
    }

    this.isWishlistLoading = true;
    const payload: any = {
      action_type: 'get',
      is_profile: true,
      offset: 0,
      limit,
      sort_by_db: '-created_dt',
    };

    this.sub.add(
      this.apiService.getWishlistData(payload).subscribe({
        next: (res) => {
          this.cdr.detectChanges();
          const items = res?.data?.part_list;
          this.wishlistItems = Array.isArray(items) ? items : [];
        },
        error: (err) => {
          console.error('Failed to load wishlist items', err);
          // this.notificationService.error(
          //   err?.error?.data?.msg ||
          //     'Failed to load wishlist items. Please try again.',
          // );

          this.wishlistItems = [];
          this.isWishlistLoading = false;
          this.cdr.detectChanges();
        },
        complete: () => {
          this.isWishlistLoading = false;
        },
      }),
    );
  }

  getWishlistMeta(item: any): string {
    if (!item) {
      return '';
    }

    const year =
      item?.year_of_manufacture ??
      item?.year ??
      item?.year_of_manufacture_s ??
      item?.year_s ??
      null;
    const model =
      item?.model ?? item?.vehicle_model_s ?? item?.vehicle_name ?? null;
    const emission =
      item?.emission_norms ??
      item?.emission_norm ??
      item?.emission_norms_s ??
      item?.emission ??
      null;

    const parts = [year, model, emission]
      .filter((value) => value !== null && value !== undefined && value !== '')
      .map((value) => `${value}`);

    return parts.join(' • ');
  }

  moveToCart(item: any) {
    this.loaderService.show();
    const payload = {
      offset: 0,
      limit: 10,
      action_type: 'ADD_DATA',
      validate_request: true,
      source: 'Online',
      part_number_list: [item?.inventory_id],
      cart_items: [
        {
          part_number: item?.inventory_id,
          delivery_type: item?.delivery_type,
          part_type: item?.part_type,
          total_quantity: item?.total_quantity ? item?.total_quantity : 1,
        },
      ],
    };
    this.sub.add(
      this.apiService.addToCart(payload).subscribe({
        next: () => {
          this.cdr.detectChanges();
          this.loadWishlistItems();
          this.removeFromWishlist(item);
          this.getCartData();
          this.loaderService.hide();
        },
        error: (err: any) => {
          // this.notificationService.error(
          //   err?.error?.data?.msg ||
          //     'Failed to move item to cart. Please try again.',
          // );
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
    this.loaderService.hide();
  }

  getWishlistPricing(item: any): {
    current: number | null;
    original: number | null;
  } {
    if (!item) {
      return { current: null, original: null };
    }

    const candidates = [
      item?.discounted_price,
      item?.base_price,
      item?.price,
      item?.price_s,
    ].filter((value) => typeof value === 'number' && !isNaN(value));

    const current = candidates.length > 0 ? candidates[0] : null;

    let original: number | null = null;
    if (
      typeof item?.price_s === 'number' &&
      current !== null &&
      item.price_s > current
    ) {
      original = item.price_s;
    } else if (
      typeof item?.mrp === 'number' &&
      current !== null &&
      item.mrp > current
    ) {
      original = item.mrp;
    }

    return { current, original };
  }

  getAddressData(showLoader: boolean = false): Promise<void> {
    return new Promise((resolve, reject) => {
      if (showLoader) {
        this.loaderService.show();
      }
      const payload = {
        offset: 0,
        limit: 10,
      };
      this.sub.add(
        this.apiService.getAddressData(payload).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.addresses = res.data;

              // If modal is open, update the pre-selected address based on current type
              if (this.Sidefilter && this.type) {
                let currentAddressId: any = null;
                if (
                  this.type === 'shipping' &&
                  this.userData?.shipping_address?.id
                ) {
                  currentAddressId = this.userData.shipping_address.id;
                } else if (
                  this.type === 'billing' &&
                  this.userData?.billing_address?.id
                ) {
                  currentAddressId = this.userData.billing_address.id;
                }

                if (currentAddressId) {
                  this.testValue = currentAddressId;
                  // Mark the current address as selected
                  this.addresses = this.addresses.map((address: any) => ({
                    ...address,
                    isSelected: this.compareIds(address.id, currentAddressId),
                  }));
                }
              }
            }
            if (showLoader) {
              this.loaderService.hide();
            }
            resolve();
          },
          error: (err: any) => {
            console.error('Error fetching address data:', err);
            // this.notificationService.error(
            //   err?.error?.data?.msg ||
            //     'Failed to load address data. Please try again.',
            // );
            if (showLoader) {
              this.loaderService.hide();
            }
            reject(err);
          },
          complete: () => {
            if (showLoader) {
              this.loaderService.hide();
            }
          },
        }),
      );
    });
  }

  removeFromWishlist(item: any) {
    this.loaderService.show();
    const payload = {
      action_type: 'delete',
      wishlist_id_list: [item?.part_number],
    };
    this.sub.add(
      this.apiService.addToWishlist(payload).subscribe({
        next: () => {
          this.cdr.detectChanges();
          this.loadWishlistItems();
          this.loaderService.hide();
          this.isWishlistExpanded = false;
        },
        error: (err: any) => {
          this.loaderService.hide();
          // this.notificationService.error(
          //   err?.error?.data?.msg ||
          //     'Failed to remove item from wishlist. Please try again.',
          // );
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
  }

  updateAddressdata(): void {
    this.loaderService.show();
    const payload = {
      id: 155,
      shipping_address: this.type === 'shipping' ? true : false,
      billing_address: this.type === 'billing' ? true : false,
    };
    this.sub.add(
      this.apiService.updateAddressdata(payload).subscribe({
        next: (res) => {
          this.loaderService.hide();
        },
        error: (err: any) => {
          console.error('Error updating address data:', err);
          // this.notificationService.error(
          //   err?.error?.data?.msg ||
          //     'Failed to update address data. Please try again.',
          // );
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
  }

  private handlePaymentStatusUpdate(statusData: any) {
    // Update local payment status
    this.isPaymentInProgress = statusData.status === 'in_progress';

    switch (statusData.status) {
      case 'success':
        // Navigate to success page or show success message
        this.router.navigate(['/order-confirmation'], {
          state: { orderDetail: this.orderDetail },
        });
        break;
      case 'failed':
        // this.notificationService.error(
        //   'Payment failed: ' + (statusData.message || 'Unknown error'),
        // );
        break;
      case 'pending':
        break;
      default:
    }
  }

  // Get current payment status for display
  getCurrentPaymentStatus(): string {
    const status = this.paymentService.getCurrentPaymentStatus();
    if (status && status.status) {
      return status.status;
    }
    return 'pending';
  }

  private loadLocalStorageItems(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const localItems = this.cartService.getLocalStorageCartItems();
    if (localItems.length > 0) {
      // Use complete product data from local storage
      this.cartItems = localItems
        .filter(
          (item: any) =>
            item && (item.inventory_id || item.part_number || item.id),
        )
        .map((item: any) => {
          const id = (
            item.inventory_id ||
            item.part_number ||
            item.id
          )?.toString();
          return {
            ...item,
            id: id,
            inventory_id: item.inventory_id || id,
            part_number: item.part_number || id,
            is_local_storage_item: true,
            quantity: item.selected_quantity || item.quantity || 1,
            total_quantity:
              item.total_quantity ||
              item.selected_quantity ||
              item.quantity ||
              1,
            unit_of_measurement:
              item.unit_of_measurement || item.selected_unit || 'Kg',
          };
        });
      // Auto-select all items by default
      this.cleanupRemovedSelectedItems(); // ✅
      this.updateSelectAllState();

      this.selectAllItems();
      this.updateSelectAllState();

      //for non-logged in users
      this.calculateLocalCartTotal();

      // Fetch available coupons for guest users too
      this.fetchCouponsData();
    } else {
      this.cartItems = [];
      this.priceDetails = null;
    }
  }

  private cleanupRemovedSelectedItems(): void {
    const currentSelectedItemIds = new Set(this.selectedItems.keys());
    const currentCartItemIds = new Set(
      this.cartItems.map((item: any) => item.id),
    );

    // Find items in selectedItems that are no longer in cartItems
    const itemsToRemove = Array.from(currentSelectedItemIds).filter(
      (id) => !currentCartItemIds.has(id),
    );

    // Remove these items from selectedItems
    itemsToRemove.forEach((id) => this.selectedItems.delete(id));
  }

  getBookingPercentage(): string {
    const scrapItem = this.cartItems.find(
      (item: any) => item?.part_type === 'Scrap Part' || item?.booking_percent_rule,
    );
    if (scrapItem?.booking_percent_rule) {
      return scrapItem.booking_percent_rule.toString();
    }
    if (this.priceDetails?.booking_percent_rule) {
      return this.priceDetails.booking_percent_rule.toString();
    }
    const base = this.getBasePrice();
    const booking = Number(this.priceDetails?.scrap_booking_amount || 0);
    if (booking > 0 && base > 0) {
      const pct = Math.round((booking / base) * 100);
      if (pct > 0 && pct <= 100) return pct.toString();
    }
    return '';
  }

  private calculateLocalCartTotal(): void {
    const localItems = this.cartService.getLocalStorageCartItems();
    if (localItems.length > 0) {
      // Use complete product data from local storage
      this.cartItems = localItems
        .filter(
          (item: any) =>
            item && (item.inventory_id || item.part_number || item.id),
        )
        .map((item: any) => {
          const id = (
            item.inventory_id ||
            item.part_number ||
            item.id
          )?.toString();
          return {
            ...item,
            id: id,
            inventory_id: item.inventory_id || id,
            part_number: item.part_number || id,
            is_local_storage_item: true,
            amount:
              item.discounted_price ||
              item.price_s ||
              item.taxable_amount ||
              0,
            quantity: item.selected_quantity || item.quantity || 1,
            total_quantity:
              item.total_quantity ||
              item.selected_quantity ||
              item.quantity ||
              1,
            unit_of_measurement:
              item.unit_of_measurement || item.selected_unit || 'Kg',
            platformCharges: 50,
            gst: item.gst_amount || 0,
            delivery_charges: 0,
            discount: item.discount_amount || 0,
          };
        });

      // Calculate price for selected items initially
      this.calculateSelectedItemsPrice();
    }
  }

  private calculateSelectedItemsPrice(): void {
    if (!this.cartItems || this.cartItems.length === 0) {
      this.priceDetails = null;
      return;
    }

    // Get selected items or all items if nothing is selected
    const itemsToCalculate =
      this.getSelectedCount() > 0
        ? Array.from(this.selectedItems.values()).map((entry) => entry.item)
        : this.cartItems;

    if (itemsToCalculate.length === 0) {
      this.priceDetails = {
        total_amount: '0.00',
        totalAmount: '0.00',
        base_price: '0.00',
        SubAmount: '0.00',
        subTotal: '0.00',
        gst_amount: '0.00',
        gstAmount: '0.00',
        delivery_charges: 0,
        deliveryCharges: 0,
        discount: '0.00',
        discountAmount: '0.00',
        platform_charges: '0.00',
        platformCharges: '0.00',
        offer_discount: 0,
        tcs_amount: 0,
        scrap_booking_amount: 0,
      };
      return;
    }

    let subTotal = 0;
    let platformCharges = 50;
    let gstAmount = 0;
    let deliveryCharges = 0;
    let discountAmount = 0;
    let scrapBookingAmount = 0;

    itemsToCalculate.forEach((item: any) => {
      const quantity =
        Number(item.selected_quantity) || Number(item.quantity) || 1;

      if (item.is_local_storage_item) {
        const itemPrice =
          Number(item.discounted_price) ||
          Number(item.taxable_amount) ||
          Number(item.price_s) ||
          0;

        if (item.part_type === 'Scrap Part') {
          if (item.booking_amount) {
            scrapBookingAmount += Number(item.booking_amount);
          }
          const totalQty = Number(item.total_quantity) || quantity;
          subTotal += itemPrice * totalQty;
        } else {
          subTotal += itemPrice * quantity;
        }

        gstAmount +=
          (Number(item.gst_amount) || Number(item.gst) || 0) * quantity;

        if (item.discount_amount) {
          discountAmount += Number(item.discount_amount) * quantity;
        } else if (
          item.price_s &&
          item.discounted_price &&
          Number(item.price_s) > Number(item.discounted_price)
        ) {
          discountAmount +=
            (Number(item.price_s) - Number(item.discounted_price)) * quantity;
        }

        if (item.delivery_charges) {
          deliveryCharges += Number(item.delivery_charges);
        }
      } else {
        subTotal += (Number(item.amount) || 0) * quantity;
        platformCharges = Number(item.platformCharges) || 50;
        gstAmount += (Number(item.gst) || 0) * quantity;
        deliveryCharges += Number(item.delivery_charges) || 0;
        discountAmount += (Number(item.discount) || 0) * quantity;
      }
    });

    const totalAmount =
      subTotal + gstAmount + deliveryCharges + platformCharges - discountAmount;

    this.priceDetails = {
      base_price: subTotal.toFixed(2),
      SubAmount: subTotal.toFixed(2),
      subTotal: subTotal.toFixed(2),
      total_amount: totalAmount.toFixed(2),
      totalAmount: totalAmount.toFixed(2),
      gst_amount: gstAmount.toFixed(2),
      gstAmount: gstAmount.toFixed(2),
      delivery_charges: deliveryCharges,
      deliveryCharges: deliveryCharges,
      discount: discountAmount.toFixed(2),
      discountAmount: discountAmount.toFixed(2),
      platform_charges: platformCharges.toFixed(2),
      platformCharges: platformCharges.toFixed(2),
      offer_discount: 0,
      tcs_amount: 0,
      scrap_booking_amount:
        scrapBookingAmount > 0 ? scrapBookingAmount.toFixed(2) : 0,
    };
  }

  onBreadcrumbClick(event: { label: string; url: any; index: number }): void {
    if (event.label === 'Cart' && this.payment) {
      this.payment = false;
      this.selectedPartNumbers = [];
      this.lable = this.authService.isLoggedIn
        ? 'Continue'
        : 'Login & Continue';
      // If clicking on Cart breadcrumb while on payment page, go back to cart
      this.cartBreadcrumbs = [{ label: 'Cart', url: '/cart' }];
      this.cdr.detectChanges();
    } else if (event.label === 'HOME') {
      // If clicking on Home breadcrumb, navigate to home
      this.router.navigate(['/home']);
    }
  }

  /**
   * Handle browser back button press
   * This will detect when user navigates back from payment gateway
   */
  @HostListener('window:popstate', ['$event'])
  onPopState(event: PopStateEvent) { }

  private disableBodyScroll(): void {
    this.modalService.openModal('cart-modal', () => this.closeModal());
  }

  private enableBodyScroll(): void {
    this.modalService.closeModal('cart-modal');
  }

  ngOnDestroy() {
    // Clean up all subscriptions
    this.destroy$.next();
    this.destroy$.complete();

    if (this.sub) {
      this.sub.unsubscribe();
    }

    // Ensure body scroll is enabled when component is destroyed
    this.enableBodyScroll();
  }
}
